
(function() {
  var result = { translations: { "fi": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} vrk", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "days": "{{ days }} vrk", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, alanro {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "fi": "static-7.1124"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1124",
    "ar-eg": "static-7.1124",
    "bg": "static-7.1124",
    "bn": "static-7.1124",
    "ca-es": "static-7.1124",
    "cs": "static-7.1124",
    "da": "static-7.1124",
    "de": "static-7.1124",
    "el": "static-7.1124",
    "en-gb": "static-7.1124",
    "en": "static-7.1124",
    "es-mx": "static-7.1124",
    "es": "static-7.1124",
    "et": "static-7.1124",
    "fi": "static-7.1124",
    "fr-ca": "static-7.1124",
    "fr": "static-7.1124",
    "he-il": "static-7.1124",
    "hi": "static-7.1124",
    "hr": "static-7.1124",
    "hu": "static-7.1124",
    "id": "static-7.1124",
    "it": "static-7.1124",
    "ja": "static-7.1124",
    "ko": "static-7.1124",
    "lt": "static-7.1124",
    "ms": "static-7.1124",
    "nl": "static-7.1124",
    "no": "static-7.1124",
    "pl": "static-7.1124",
    "pt-br": "static-7.1124",
    "pt-pt": "static-7.1124",
    "ro": "static-7.1124",
    "ru": "static-7.1124",
    "sk": "static-7.1124",
    "sl": "static-7.1124",
    "sv": "static-7.1124",
    "th": "static-7.1124",
    "tl": "static-7.1124",
    "tr": "static-7.1124",
    "uk": "static-7.1124",
    "vi": "static-7.1124",
    "x-pseudo": "static-7.1124",
    "zh-cn": "static-7.1124",
    "zh-hk": "static-7.1124",
    "zh-tw": "static-7.1124"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:fi', {version: 'static-7.1124'}); }
})();


